import {ReadinessIcon,ReadinessNavLink} from './BuildingReadiness';
import {useLocation} from 'react-router';
import {navigationIcon} from './Icon';

type Destination={href:string;label:string;id?:string};
/** Keep the current permitted page visible without expanding every occasional tool. */
export function WorkspaceMoreLinks({items,isCurrent,summary='More views',className=''}:{
 items:ReadonlyArray<Destination>;isCurrent:(item:Destination)=>boolean;summary?:string;className?:string;
}){
 const location=useLocation(),selected=items.find(isCurrent);
 const remaining=items.filter(item=>item.href!==selected?.href);
 const link=(item:Destination,current=false)=><li key={item.id??item.href}>
  <ReadinessNavLink to={item.href} aria-current={current?'page':undefined}><ReadinessIcon name={navigationIcon(item.label)} href={item.href}/><span>{item.label}</span></ReadinessNavLink>
 </li>;
 return <>
  {selected&&<ul className="workspace-family-navigation__current">{link(selected,true)}</ul>}
  {remaining.length>0&&<details className={'workspace-family-navigation__more '+className} key={location.pathname+selected?.href}>
   <summary>{summary}</summary><ul>{remaining.map(item=>link(item))}</ul>
  </details>}
 </>;
}
